export default __webpack_public_path__ + "static/media/redbag.28b70107.svg";